"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = add;

var _init = _interopRequireDefault(require("./_init"));

var _data = _interopRequireDefault(require("./_data"));

// adds unique nodes to mq collection
function add(selector) {
  var idMap = {};
  var result;
  var nodes = new _init["default"](selector);

  if (this.length) {
    result = new _init["default"]();

    for (var i = 0; i < this.length; i++) {
      var node = this[i];
      var nodeID = node.b$ = node.b$ || ++_data["default"].nodeIndex; // eslint-disable-line no-plusplus

      idMap[nodeID] = 1;
      result.push(node);
    }

    for (var _i = 0; _i < nodes.length; _i++) {
      var _node = nodes[_i];

      var _nodeID = _node.b$ = _node.b$ || ++_data["default"].nodeIndex; // eslint-disable-line no-plusplus


      if (!idMap[_nodeID]) {
        idMap[_nodeID] = 1;
        result.push(_node);
      }
    }
  } else {
    result = nodes;
  }

  return result;
}
//# sourceMappingURL=add.js.map